module.exports = __webpack_public_path__ + "img/AE5005-P31.3f68173d.jpg";